export const EVENT_OPTIONS = [
  {
    id: 1,
    label: "Påminnelse 1",
    value: "REMINDER_1",
  },
  {
    id: 2,
    label: "Påminnelse 2",
    value: "REMINDER_2",
  },
  {
    id: 4,
    label: "Inkasso",
    value: "COLLECTION",
  },
];
